<!-- User Fia Application Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  #userFiaApplicationModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }}</h4>
        <h4
          *ngIf="this.fiaLeftToApplyFor"
          class="modal-title w-100"
          style="text-align: right; margin-right: 25px"
          data-mdb-toggle="tooltip"
          data-mdb-placement="top"
          title="Total Applied for this year: {{ this.fiaLeftToApplyFor.totalAppliedForCurrentYear | number }}
Total Pin Balance: {{ this.fiaLeftToApplyFor.pinTotalAvailableBalance | number }}          
Pending Applications Total: {{ this.fiaLeftToApplyFor.totalAmountRequested | number }} ({{ this.fiaLeftToApplyFor.pendingAppCount }} apps)
FIA Available {{ this.fiaLeftToApplyFor.fiaAvailable | number }}"
        >
          FIA Left To Apply For: R {{ this.fiaLeftToApplyFor.amount | number }}
        </h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <div id="fiaApplicationBody" *ngIf="!isPending">
            <!--Main Body-->
            <div class="d-block col-12 mb-3 text-center">
              <p class="font-weight-bold mb-1">New FIA Application</p>
              <p class="small">Max Trade: {{ fiaLeftToApplyFor.maxTradeAmount }} | Balance: {{ fiaLeftToApplyFor.bankBalance }}</p>
            </div>
            <!-- FIA Amount -->
            <div class="md-form col-12" style="margin-top: 5px">
              <input
                [(ngModel)]="newFia.fiaAmount"
                mdbInput
                mdbValidate
                name="fiaAmount"
                type="number"
                id="fiaAmount"
                class="form-control"
                #fiaAmount="ngModel"
                required
              />
              <label for="fiaAmount">FIA Amount</label>
              <mdb-error *ngIf="fiaAmount.invalid && (fiaAmount.dirty || fiaAmount.touched)">FIA Amount is required </mdb-error>
              <mdb-success *ngIf="fiaAmount.valid && (fiaAmount.dirty || fiaAmount.touched)"></mdb-success>
            </div>
            <div class="d-block col-12 mb-3 text-center">
              <p class="font-weight-bold mb-1">Supporting Documentation</p>
            </div>
            <p class="text-left">This is where you can upload the supporting documents that are included with this FIA application</p>
            <!--Main Body-->
            <div class="selection-item-full">
              <div class="dropzone" filedropzone="">
                <div class="text-wrapper">
                  <i class="fas fa-upload"></i>
                  <p class="hidden-sm-down">
                    <a class="is-link"><strong>Browse</strong></a> to select files from your computer
                  </p>
                  <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
                </div>
                <input
                  class="hidden w-100 h-100"
                  type="file"
                  multiple="multiple"
                  #file
                  (change)="onFileChange($event)"
                  name="fileUploadArea"
                />
              </div>
            </div>

            <div class="d-block col-12" *ngIf="userNewDocuments?.length > 0">
              <p class="font-weight-bold mb-1">New Documents</p>
            </div>
            <table class="col-12" mdbTable *ngIf="userNewDocuments?.length > 0" hover="true" small="true" responsive="true">
              <thead>
                <tr>
                  <th scope="col" class="col-4">File Name</th>
                  <th scope="col" class="col-6">Type</th>
                  <th scope="col" class="col-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let docs of userNewDocuments">
                  <td class="align-middle">{{ docs.fileName }}</td>
                  <td class="align-middle">
                    <select
                      class="form-control"
                      [(ngModel)]="docs.fileType"
                      placeholder="Select document type"
                      required
                      name="fileType"
                      style="display: block !important"
                    >
                      <option ngValue="Loan Agreement">Loan</option>
                      <option ngValue="Proof Of Source">Savings/Cash</option>
                      <option ngValue="Other">Other</option>
                    </select>
                  </td>
                  <td class="align-middle">
                    <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(docs.fileName)" mdbWavesEffect>Remove</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--Loading-->
        <div *ngIf="busy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button
          *ngIf="!busy && !isPending && !supportingApplicationDocumentsError && userNewDocuments.length > 0 && newFia.fiaAmount > 0"
          type="button"
          mdbBtn
          color="trakly-action"
          class="relative waves-light"
          (click)="fiaApplicationApplyClicked()"
        >
          Apply
        </button>
        <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">Close</button>
      </div>
    </div>
  </div>
</div>
